<template>
  <div class="ticket--detail_for_purchase_history">
    <div class="ticket-box">
      <span v-if="isTicketExpired" class="tag">期限切れ</span>
      <span class="ticket-image">
        <a :href="linkUrl" target="_blank">
          <img :src="imageUrl" />
        </a>
      </span>
      <div class="ticket-info">
        <p class="ticket__brand--small">
          {{ brandName }}
        </p>
        <p class="ticket__item-name">
          {{ itemName }}
        </p>
        <p v-if="isNotEmptyItemSkuName" class="ticket__item-min-unit">
          {{ itemSkuName }}
        </p>
        <p
          v-if="isNotEmptyOtherItemSkuContentsCount"
          class="ticket__other-amounts"
        >
          <span>他{{ otherItemSkuContentsCount }}枚</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    linkUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    isTicketExpired: {
      type: Boolean,
      required: true
    },
    otherItemSkuContentsCount: {
      type: Number,
      required: true
    }
  },
  computed: {
    isNotEmptyItemSkuName() {
      return this.itemSkuName !== ''
    },
    isNotEmptyOtherItemSkuContentsCount() {
      return this.otherItemSkuContentsCount > 0
    }
  }
}
</script>
<style lang="scss" scoped>
.ticket {
  &-box {
    height: auto;
    display: flex;
  }

  &-image {
    height: 100%;
    font-size: 0;
  }

  &-image img {
    height: 80px;
    border-radius: 8px;
    width: 80px;
  }

  &-info {
    overflow: hidden;
    width: 100%;
    padding: 0 0 0 16px;
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  &__item-name {
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 1.6;
    overflow: hidden;
    text-overflow: initial;
    white-space: normal;
    padding-bottom: 2px;
    color: $black;
    word-break: break-word;
  }

  &__item-min-unit {
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 1.6;
    overflow: unset;
    text-overflow: unset;
    white-space: unset;
    padding-bottom: 2px;
    color: $black;
    width: 100%;
    word-break: break-word;
  }

  &__brand--small {
    font-size: 1rem;
    line-height: 1.6;
    color: $gray-1;
    text-align: left;
    overflow: unset;
    text-overflow: unset;
    white-space: unset;
    font-weight: bold;
    padding-bottom: 2px;
    width: 100%;
    word-break: break-word;
  }
}

.ticket--detail_for_purchase_history {
  .ticket__other-amounts {
    @extend %minimal;
    margin-top: auto;
    text-align: right;
  }
}
</style>
